<template>
  <div :class="$style.profile">
    <div :class="$style.header">
      <ChannelChip
        :channel="user.channel"
        :class="$style.channel"
        v-if="mustShowChip"
      />
      <p :class="$style.brief">{{ brief }}</p>
    </div>
    <p :class="[$style.name, $style.profile__name]">{{ user.nickname }}</p>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import ChannelChip from '@/components/atoms/ChannelChip.vue'

import type { KarteUserProfileUserFragment } from './KarteUserProfile.generated'
import { GenderToString } from '@/models/gender/GenderToString'
import { prefectureLabel } from '@/features/prefecture/prefecture'
import { isPartnerChannel } from '@/models/channel/channel'

const props = defineProps<{
  user: KarteUserProfileUserFragment
}>()

const formatUserProfile = (user: KarteUserProfileUserFragment): string => {
  const age = user.birthYear
    ? `${new Date().getFullYear() - user.birthYear}歳`
    : undefined
  const genderLabel = user.gender ? GenderToString[user.gender] : undefined
  const address = (() => {
    if (user.address) {
      return user.address.prefecture + ' ' + user.address.city
    }
    return user.livingPrefecture
      ? prefectureLabel(user.livingPrefecture)
      : undefined
  })()
  return [address, age, genderLabel].filter(value => value != null).join('・')
}

const mustShowChip = computed(() => isPartnerChannel(props.user.channel))
const brief = computed(() => formatUserProfile(props.user))
</script>

<style lang="scss" module>
.profile {
  &__name {
    margin-top: 6px;
  }
}

.header {
  display: flex;
  align-items: center;
  gap: 8px;
}

.channel {
  flex-shrink: 0;
}

.name {
  overflow: hidden;
  flex: 1;
  font-size: 14px;
  font-weight: bold;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.brief {
  color: $color-text-and-object-medium-emphasis;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
